import moment from 'moment';
import axios from 'axios';
import getUrl from 'utils/getUrl';
import { generateTakerRejection } from './utils/takerApiUtils';
import { mapTakerSurveyFromApiModel } from './dataMapper/takerDataMapper';

const toCaseApiParams = ({
  responseId,
  caseId,
  ticketId,
  questionItemId,
  optionUuid,
  followingResponseUuid,
}) => ({
  rid: responseId,
  cid: caseId,
  tid: ticketId,
  qid: questionItemId,
  ouuid: optionUuid,
  following: followingResponseUuid,
});

const tz = moment.tz.guess();

export default (uuid, caseParams = {}) =>
  axios
    .get(getUrl.api(`/survey/data/${uuid}`), {
      params: {
        ...toCaseApiParams(caseParams),
        tz,
      },
    })
    .catch(generateTakerRejection())
    .then(({ data }) => mapTakerSurveyFromApiModel(data));
